import React from 'react';
import '../../styles/App.css';
import '../../styles/Table.css'


/**
 * Class used to render the Calibration Data for GME Vins
 *
 * @author Ethan Jones
 */
class DthCalibrationTable extends React.Component{

    /**
     * Iterates through modules checking if they have hardware dependencies, if so, uses the selected hardware part
     * number to display the proper calibration for that module
     *
     * @returns {*}
     */
    renderDthHwdCalibrationTable(){
    const hardwareData = this.props.progSeqData.dthHardwareCopMap[this.props.hardwareId];
    return(
        <table className={"DthCalibrationTable"}>
            <tr>
                <th>Module</th>
                <th>Part Number</th>
                <th>CVN</th>
            </tr>
            {hardwareData && hardwareData.map((data, index) =>(
                <tr>
                    <td>{data[1]}</td>
                    <td>{data[0]}</td>
                    <td>{this.props.progSeqData.cvnMap[data[0]]}</td>
                </tr>
            ))}
        </table>
    )
    }

    /**
     * Iterates through the chain of parts in Calibration Data Object, displaying the data in a table to thr front end
     * @returns {*}
     */
    renderDthCalibrationTable(){
        return(
            <table className={"DthCalibrationTable"}>
                <tr>
                    <th>Module</th>
                    <th>CVN</th>
                    <th>Part Number</th>
                </tr>
                {this.props.modules && this.props.modules.map((data,index)=>(
                    <tr>
                        <td>{data[1]}</td>
                        <td>{this.props.progSeqData.cvnMap[this.props.chainOfParts[data[0]][0][0]]}</td>
                        <td>{this.props.chainOfParts[data[0]][0][0]}</td>
                    </tr>
                ))}
            </table>
        )
    }


    /**
     * Main render method for DthCalibrationTable
     * @returns {*}
     */
    render(){

        return(
            <div>
                <div>
                    { this.props.progSeqData.hasDependency ?(
                        this.renderDthHwdCalibrationTable()
                    ):(
                        this.renderDthCalibrationTable())
                    }
                </div>
            </div>
        )
    }
}


export default DthCalibrationTable;